export function getSousCibles (state) {
  return state.cibles
}

export function getFormFields (state) {
  return state.formFields
}

export function getFilters (state) {
  return state.filters
}

export function getPagination (state) {
  return state.pagination
}

export function getCurrentSousCible (state) {
  return state.currentSousCible
}
